module.exports = __webpack_public_path__ + "img/logo.2460ac8.svg";